import React from "react";
import { Link } from "react-router-dom";

import approvedHome from "../assets/images/goatfight-home-approved.png";
import "../assets/css/sports-home.css";

const hotspots = [
  ["reference-home__home", "/", "Home"],
  ["reference-home__nba-nav", "/nba", "NBA"],
  ["reference-home__golf-nav", "/golf", "Golf"],
  ["reference-home__how", "/#how-it-works", "How it works"],
  ["reference-home__login", "/login", "Login"],
  ["reference-home__join", "/signup", "Join now"],
  ["reference-home__nba-card", "/nba", "Enter NBA"],
  ["reference-home__golf-card", "/golf", "Enter Golf"],
];

const SportsHome = () => (
  <main className="reference-home">
    <div className="reference-home__canvas">
      <img
        className="reference-home__art"
        src={approvedHome}
        alt="GoatFight — choose between legendary NBA and Golf simulations"
      />

      <nav aria-label="GoatFight homepage navigation">
        {hotspots.map(([className, path, label]) => (
          <Link className={`reference-home__hotspot ${className}`} to={path} key={label}>
            <span>{label}</span>
          </Link>
        ))}
      </nav>
    </div>
  </main>
);

export default SportsHome;
